module.exports = __webpack_public_path__ + "static/media/raghu.8ffec7f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/pics/raghu.jpg
// module id = 144
// module chunks = 0